<template>
  <div class="branch-box" :class="{'start-node': isStart}">
    <slot />
  </div>
</template>

<script>
export default {
  props: {
    isStart: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
@mixin layCenter {
  display: flex;
  align-items: stretch;
  justify-content: center;
}
.branch-box {
  width: 100%;
  @include layCenter;
  border-bottom: 2px solid #CACACA;
  border-top: 2px solid #CACACA;
  position: relative;
}
</style>
